const formatPriceToEuro = (priceInCents: number): string => {
  // Convert cents to currency
  const price = priceInCents / 100;
  if (!isFinite(price) || isNaN(price)) {
    return '€0.00';
  }
  try {
    return new Intl.NumberFormat('de-DE', {
      style: 'currency',
      currency: 'EUR',
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(price);
  } catch (error) {
    console.warn('Failed to format price:', error);
    return `€${price.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
  }
};

export { formatPriceToEuro };
